// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eKutirHead {
    font-size: 60px !important;
    color:var(--white-color) !important;
    font-weight: 900 !important;
    font-style: normal !important;
}

.eKutirHeading-2 {
    font-size: 40px !important;
    color:var(--white-color) !important;
    font-weight: 700 !important;
}

.eKutirHeading-3 {
    font-size: 20px !important;
    color:var(--white-color) !important;
}

.textAlign {
    background-color:var(--secondary-color) !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 60px !important;
    color:var(--white-color) !important;
    padding: 1.2rem 0.5rem 1.2rem 0.5rem;
    border: none;
}

.submitBtn {
    background-color: var(--primary-color) !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 6px !important;
    color:var(--white-color) !important;
    padding: 1rem 2rem !important;
    border: none !important;
    cursor: pointer !important;
}

.fieldAign {
    max-width: 500px !important;
    margin: auto !important;
}


.login-content-1 {
    font-size: 35px !important;
    color:var(--black-color) !important;
    font-weight: 700 !important;
}

.login-content-2 {
    font-size: 16px !important;
    color:var(--black-color) !important;
}

.logiTextFieldAlign {
    padding: 16rem 0rem !important;
}
.eKutirHead {
    font-size: 60px !important;
    color:var(--white-color) !important;
    font-weight: bold !important;
}

.eKutirHeading-2 {
    font-size: 40px !important;
    color:var(--white-color) !important;;
    font-weight: 700 !important;
}

.eKutirHeading-3 {
    font-size: 20px !important;
    color:var(--white-color) !important;
}

.cardAlign{
    display: flex;
    background-color: var(--primary-color) !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

@media (max-width: 599.98px) {
    .logiTextFieldAlign {
        padding: 4rem 1rem !important;
    }
}

@media (min-width: 600px) and (max-width: 899.98px) {
    .logiTextFieldAlign {
        padding: 4rem 1rem !important;
    }
}

@media (min-width: 900px) and (max-width: 1199.98px) {
    .logiTextFieldAlign {
        padding: 6rem 1rem !important;
    }
    .eKutirHead {
        font-size: 40px !important;
    }
    .eKutirHeading-2 {
        font-size: 24px !important;
    }
    
    .eKutirHeading-3 {
        font-size: 12x !important;
    }
    .textAlign {
        padding: 0.8rem 0.5rem 0.8rem 0.5rem !important;
        margin: 0px 34px !important;
    }
    
}

@media (min-width: 1200px) and (max-width: 1535.98px) {
    .logiTextFieldAlign {
        padding: 11rem 1rem !important;
    }
}

@media (min-width: 1536px) {}`, "",{"version":3,"sources":["webpack://./src/app/auth/login/login.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,mCAAmC;IACnC,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,kDAAkD;IAClD,qCAAqC;IACrC,2BAA2B;IAC3B,8BAA8B;IAC9B,mCAAmC;IACnC,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,iDAAiD;IACjD,qCAAqC;IACrC,2BAA2B;IAC3B,6BAA6B;IAC7B,mCAAmC;IACnC,6BAA6B;IAC7B,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;;AAGA;IACI,0BAA0B;IAC1B,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,0BAA0B;IAC1B,mCAAmC;IACnC,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,iDAAiD;IACjD,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;IAC7B;IACA;QACI,+CAA+C;QAC/C,2BAA2B;IAC/B;;AAEJ;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA,4BAA4B","sourcesContent":[".eKutirHead {\n    font-size: 60px !important;\n    color:var(--white-color) !important;\n    font-weight: 900 !important;\n    font-style: normal !important;\n}\n\n.eKutirHeading-2 {\n    font-size: 40px !important;\n    color:var(--white-color) !important;\n    font-weight: 700 !important;\n}\n\n.eKutirHeading-3 {\n    font-size: 20px !important;\n    color:var(--white-color) !important;\n}\n\n.textAlign {\n    background-color:var(--secondary-color) !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 60px !important;\n    color:var(--white-color) !important;\n    padding: 1.2rem 0.5rem 1.2rem 0.5rem;\n    border: none;\n}\n\n.submitBtn {\n    background-color: var(--primary-color) !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 6px !important;\n    color:var(--white-color) !important;\n    padding: 1rem 2rem !important;\n    border: none !important;\n    cursor: pointer !important;\n}\n\n.fieldAign {\n    max-width: 500px !important;\n    margin: auto !important;\n}\n\n\n.login-content-1 {\n    font-size: 35px !important;\n    color:var(--black-color) !important;\n    font-weight: 700 !important;\n}\n\n.login-content-2 {\n    font-size: 16px !important;\n    color:var(--black-color) !important;\n}\n\n.logiTextFieldAlign {\n    padding: 16rem 0rem !important;\n}\n.eKutirHead {\n    font-size: 60px !important;\n    color:var(--white-color) !important;\n    font-weight: bold !important;\n}\n\n.eKutirHeading-2 {\n    font-size: 40px !important;\n    color:var(--white-color) !important;;\n    font-weight: 700 !important;\n}\n\n.eKutirHeading-3 {\n    font-size: 20px !important;\n    color:var(--white-color) !important;\n}\n\n.cardAlign{\n    display: flex;\n    background-color: var(--primary-color) !important;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n}\n\n@media (max-width: 599.98px) {\n    .logiTextFieldAlign {\n        padding: 4rem 1rem !important;\n    }\n}\n\n@media (min-width: 600px) and (max-width: 899.98px) {\n    .logiTextFieldAlign {\n        padding: 4rem 1rem !important;\n    }\n}\n\n@media (min-width: 900px) and (max-width: 1199.98px) {\n    .logiTextFieldAlign {\n        padding: 6rem 1rem !important;\n    }\n    .eKutirHead {\n        font-size: 40px !important;\n    }\n    .eKutirHeading-2 {\n        font-size: 24px !important;\n    }\n    \n    .eKutirHeading-3 {\n        font-size: 12x !important;\n    }\n    .textAlign {\n        padding: 0.8rem 0.5rem 0.8rem 0.5rem !important;\n        margin: 0px 34px !important;\n    }\n    \n}\n\n@media (min-width: 1200px) and (max-width: 1535.98px) {\n    .logiTextFieldAlign {\n        padding: 11rem 1rem !important;\n    }\n}\n\n@media (min-width: 1536px) {}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
